<template>
  <pop-up-layout 
    :title="$t('reservas.contrato.firmaContrato')"
    :description="$t('reservas.contrato.firmantesAdded')"
    @volver="$parent.hide()"
    :ocultarVolver="true"
  >    
    <v-layout mb-3 justify-center>
      <v-icon color="primary" class="custom-icon icon-job" style="font-size:200px;"/>
    </v-layout>
    <v-layout mb-3 class="subheading grey--text text--darken-1">
      <v-flex xs12 class="text-xs-center">
        <span v-if="!incrustado">
          {{$t('reservas.contrato.esperarAviso')}}
        </span>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-btn 
        large color="primary"
        @click="$emit('continuar')"
        :disabled="cargandoExterior"
        :loading="cargandoExterior"
      >
       {{$t('reservas.contrato.aceptar')}}
      </v-btn>
    </v-layout>
  </pop-up-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    incrustado: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      usuario: 'login/usuario'
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/components/reservas/contratos/ContratoTerminar.vue